export default __webpack_public_path__ + "static/media/perfil.513614a5.png";